/**
 * The classification keys a new material carries in its `speckleUserParameters`.
 *
 * The API classifies a created material from exactly two of these keys — `BIMTypeCode` for the code
 * and `classificationObjectClass` for the object class — and writes the code onto the project's
 * configured classification parameter from there. It never reads `CCSClassification`; that key stays
 * only because the edit dialog and the inspect views fall back to it when the configured parameter
 * is missing.
 *
 * Both create containers used to build this by hand. The type container swapped the code and the
 * object class and left `BIMTypeCode` empty for CCI/CCS/Uniclass (whose codes arrive through the
 * object-class path, not the plain BIM-code path), so the API skipped the classification and the
 * material landed under "No classification code" in the Project Breakdown (RTLCA-5774). The material
 * container overwrote every row's `BIMTypeCode` with the group-level code, which for those systems was
 * empty as well.
 *
 * @param code - The classification code the user picked, e.g. "EF_25_10_40"
 * @param objectClass - Its object class for CCI/CCS/Uniclass ("EF", "[L]", …); empty or undefined for systems without one
 */
export function classificationUserParameters(code: string, objectClass?: string | null): Record<string, string> {
  return {
    BIMTypeCode: code,
    CCSClassification: code,
    classificationObjectClass: objectClass ?? "",
  };
}
